import clientEnv from '../global/clientEnv'

// Use `any` for the client type to avoid static imports of rise-sdk/protobuf,
// which cause runtime crashes due to symlinked proto files outside the workspace.
let client: any = null

export function initRiseClient(): void {
  if (client) return
  import('@instacart/rise-sdk')
    .then(({ RiseClient, RiseEnvironment }) => {
      let environment: any
      switch (clientEnv.PUBLIC_CLIENT_ENVIRONMENT) {
        case 'production':
          environment = RiseEnvironment.PROD
          break
        case 'staging':
          environment = RiseEnvironment.STG
          break
        default:
          environment = RiseEnvironment.DEV
      }
      client = new RiseClient({
        environment,
        logger: {
          error: () => {},
          warn: () => {},
          info: () => {},
          debug: () => {},
          defaultOwner: () => '',
        },
        metrics: { increment: () => {}, gauge: () => {} },
      })
    })
    .catch(() => {
      // RISE client creation should never break the app
    })
}

export function getRiseClient(): any {
  return client
}
